import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectPrice = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('price')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
